import React, { FC, ReactElement } from 'react'
import styles from './ButtonOutlined.module.css'
import classNames from 'classnames'

const ButtonOutlined: FC<{
	children: React.ReactNode
	className?: string
	type?: 'button' | 'submit' | 'reset'
	onClick?: (evt: any) => void
	disabled?: boolean
	size?: 'small' | 'medium' | 'large'
}> = (props): ReactElement => {
	return (
		<button
			disabled={props.disabled}
			onClick={props?.onClick}
			className={classNames(
				{
					[(props.className as any)]: !!props.className,
					[styles.small]: props?.size === 'small',
					[styles.medium]: props?.size === 'medium',
					[styles.large]: props?.size === 'large'
				},
				styles.root
			)}
			type={props.type || 'button'}
		>
			{props.children}
		</button>
	)
}

export default ButtonOutlined
